function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.61,62.502c-1.689-10.044-7.93-18.687-16.705-23.547c4.15-4.132,6.723-9.847,6.723-16.152 C55.628,10.229,45.399,0,32.826,0C20.252,0,10.023,10.229,10.023,22.803c0,6.305,2.573,12.02,6.723,16.151 C7.974,43.816,1.73,52.465,0.042,62.502c-0.274,1.635,0.827,3.182,2.461,3.456C2.671,65.987,2.84,66,3.004,66 c1.438,0,2.708-1.037,2.955-2.503C7.5,54.334,13.674,46.582,22.19,42.965c3.178,1.684,6.796,2.642,10.636,2.642 s7.459-0.958,10.637-2.643c8.519,3.617,14.688,11.364,16.23,20.533C59.939,64.963,61.21,66,62.648,66c0.165,0,0.332-0.013,0.5-0.042 C64.783,65.684,65.885,64.137,65.61,62.502 M16.023,22.803C16.023,13.538,23.562,6,32.826,6c9.266,0,16.802,7.538,16.802,16.803 s-7.536,16.803-16.802,16.803C23.562,39.606,16.023,32.068,16.023,22.803"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "-0.08 -0.974 66 67",
    enableBackground: "new -0.08 -0.974 66 67",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.e7c24816.svg";
export { ForwardRef as ReactComponent };